let AdobeAn;
let exportRoot;
import createjs from 'createjs';
/* eslint-disable camelcase */
(function(cjs, an) {
    let p; // shortcut to reference prototypes
    const lib = {};
    const ss = {};
    const img = {};
    lib.ssMetadata = [];

    // symbols:
    // helper functions:

    function mc_symbol_clone() {
        const clone = this._cloneProps(new this.constructor(this.mode, this.startPosition, this.loop));
        clone.gotoAndStop(this.currentFrame);
        clone.paused = this.paused;
        clone.framerate = this.framerate;
        return clone;
    }

    function getMCSymbolPrototype(symbol, nominalBounds, frameBounds) {
        const prototype = cjs.extend(symbol, cjs.MovieClip);
        prototype.clone = mc_symbol_clone;
        prototype.nominalBounds = nominalBounds;
        prototype.frameBounds = frameBounds;
        return prototype;
    }

    (lib.Symbol1sd = function(mode, startPosition, loop) {
        this.initialize(mode, startPosition, loop, {});

        // Layer_1
        this.shape = new cjs.Shape();
        this.shape.graphics
            .lf(['rgba(255,255,255,0.698)', 'rgba(255,255,255,0)'], [0, 1], -16.6, -95, 10, 57)
            .s()
            .p('ABaMZIl86lIDKBzIF7amg');
        this.shape.setTransform(27.3, 15.8);

        this.shape_1 = new cjs.Shape();
        this.shape_1.graphics
            .lf(['rgba(255,255,255,0.698)', 'rgba(255,255,255,0)'], [0, 1], -11.4, -65.1, 15.2, 86.9)
            .s()
            .p('AgtLKIl86lIHWERIF9amg');
        this.shape_1.setTransform(-13.8, -7.9);

        this.timeline.addTween(
            cjs.Tween.get({})
                .to({state: [{t: this.shape_1}, {t: this.shape}]})
                .wait(1)
        );
    }).prototype = getMCSymbolPrototype(lib.Symbol1sd, new cjs.Rectangle(-56.4, -106.6, 112.8, 213.3), null);

    // stage content:
    (lib._7 = function(mode, startPosition, loop) {
        this.initialize(mode, startPosition, loop, {});

        // Layer_3 (mask)
        const mask = new cjs.Shape();
        mask._off = true;
        mask.graphics.p('AtXD3IAA3KIavPdIAAXKg');
        mask.setTransform(85.6, 127.6);

        // Layer_2
        this.instance = new lib.Symbol1sd();
        this.instance.parent = this;
        this.instance.setTransform(-64.8, 41.2);

        const maskedShapeInstanceList = [this.instance];

        for (let shapedInstanceItr = 0; shapedInstanceItr < maskedShapeInstanceList.length; shapedInstanceItr++) {
            maskedShapeInstanceList[shapedInstanceItr].mask = mask;
        }

        this.timeline.addTween(
            cjs.Tween.get(this.instance)
                .to({x: 227.6, y: 209}, 23, cjs.Ease.quadInOut)
                .wait(22)
        );

        // Слой 1
        this.shape = new cjs.Shape();
        this.shape.graphics
            .f('#FFFFFF')
            .s()
            .p('AlxieIAAhsILjGpIAABsg');
        this.shape.setTransform(125.2, 181.8);

        this.shape_1 = new cjs.Shape();
        this.shape_1.graphics
            .f('#FFFFFF')
            .s()
            .p('AlxifIAAhrILjGpIAABsg');
        this.shape_1.setTransform(39.1, 133.2);

        this.shape_2 = new cjs.Shape();
        this.shape_2.graphics
            .f('#FFFFFF')
            .s()
            .p('AsfmXIAAhsIY/ObIAABsg');
        this.shape_2.setTransform(82.1, 139);

        this.shape_3 = new cjs.Shape();
        this.shape_3.graphics
            .f('#9AA5C0')
            .s()
            .p('AtXlXIAAktIavPcIAAEtg');
        this.shape_3.setTransform(85.6, 100.8);

        this.shape_4 = new cjs.Shape();
        this.shape_4.graphics
            .f('#9AA5C0')
            .s()
            .p('AgerQIA+goIAAXKIg+Ang');
        this.shape_4.setTransform(174.4, 175);

        this.shape_5 = new cjs.Shape();
        this.shape_5.graphics
            .f('#E7E7E7')
            .s()
            .p('At3nZIBAgoIavPbIg/Aog');
        this.shape_5.setTransform(88.8, 51.4);

        this.shape_6 = new cjs.Shape();
        this.shape_6.graphics
            .f('#B9C4E3')
            .s()
            .p('AtXD3IAA3JIavPcIAAXJg');
        this.shape_6.setTransform(85.6, 127.6);

        this.timeline.addTween(
            cjs.Tween.get({})
                .to({
                    state: [{t: this.shape_6}, {t: this.shape_5}, {t: this.shape_4}, {t: this.shape_3}, {t: this.shape_2}, {t: this.shape_1}, {t: this.shape}]
                })
                .wait(45)
        );
    }).prototype = p = new cjs.MovieClip();
    p.nominalBounds = new cjs.Rectangle(89, 126, 177.6, 251.1);
    // library properties:
    lib.properties = {
        id: '037CDFFC79484230967FF38F3494E889',
        width: 178,
        height: 252,
        fps: 24,
        color: '#CCCCCC',
        opacity: 0.0,
        manifest: [],
        preloads: []
    };

    // bootstrap callback support:

    (lib.Stage = function(canvas) {
        createjs.Stage.call(this, canvas);
    }).prototype = p = new createjs.Stage();

    p.setAutoPlay = function(autoPlay) {
        this.tickEnabled = autoPlay;
    };
    p.play = function() {
        this.tickEnabled = true;
        this.getChildAt(0).gotoAndPlay(this.getTimelinePosition());
    };
    p.stop = function(ms) {
        if (ms) this.seek(ms);
        this.tickEnabled = false;
    };
    p.seek = function(ms) {
        this.tickEnabled = true;
        this.getChildAt(0).gotoAndStop((lib.properties.fps * ms) / 1000);
    };
    p.getDuration = function() {
        return (this.getChildAt(0).totalFrames / lib.properties.fps) * 1000;
    };

    p.getTimelinePosition = function() {
        return (this.getChildAt(0).currentFrame / lib.properties.fps) * 1000;
    };

    an.bootcompsLoaded = an.bootcompsLoaded || [];
    if (!an.bootstrapListeners) {
        an.bootstrapListeners = [];
    }

    an.bootstrapCallback = function(fnCallback) {
        an.bootstrapListeners.push(fnCallback);
        if (an.bootcompsLoaded.length > 0) {
            for (let i = 0; i < an.bootcompsLoaded.length; ++i) {
                fnCallback(an.bootcompsLoaded[i]);
            }
        }
    };

    an.compositions = an.compositions || {};
    an.compositions['037CDFFC79484230967FF38F3494E889'] = {
        getStage: function() {
            return exportRoot.getStage();
        },
        getLibrary: function() {
            return lib;
        },
        getSpriteSheet: function() {
            return ss;
        },
        getImages: function() {
            return img;
        }
    };

    an.compositionLoaded = function(id) {
        an.bootcompsLoaded.push(id);
        for (let j = 0; j < an.bootstrapListeners.length; j++) {
            an.bootstrapListeners[j](id);
        }
    };

    an.getComposition = function(id) {
        return an.compositions[id];
    };
})((createjs = createjs || {}), (AdobeAn = AdobeAn || {}));

const composition = AdobeAn.getComposition('037CDFFC79484230967FF38F3494E889');

export {AdobeAn};
export {composition};
